import * as Yup from 'yup';
import * as moment from 'moment';
import { FORMAT } from '../utils/dateOfBirthValidation';

export function getInitialValues(pageData) {
    let accountType = ''
    if (pageData?.accountType === "INDIVIDUAL") accountType = "Individual"
    else if (pageData?.accountType === "CORPORATE_ADMIN") accountType = "Corporate"

    let taxExemptionExpireDate = moment(new Date().setDate(new Date().getDate())).format(FORMAT)

    return {
        name: pageData?.userDetails?.userName || '',
        accountType: accountType || '',
        deliveryWindowBegin: pageData?.postPreferences?.officeHourStart || '08:00',
        deliveryWindowEnd: pageData?.postPreferences?.officeHourEnd || '17:00',
        email: pageData?.userDetails?.emailId || '',
        companyName: pageData?.userDetails?.companyName || '',
        line1: pageData?.userDetails?.address?.address1 || '',
        line2: pageData?.userDetails?.address?.address2 || '',
        city: pageData?.userDetails?.address?.city || '',
        state: pageData?.userDetails?.address?.state || '',
        stateTaxExemption: pageData?.userDetails?.address?.state,
        zip: pageData?.userDetails?.address?.zipCode || '',
        taxExemptionExpireDate: taxExemptionExpireDate,
        editStateTaxExemption: '',
        editTaxExemptionExpireDate: taxExemptionExpireDate,
        day0: pageData?.postPreferences?.dayOfWeeks?.length > 0 ? pageData?.postPreferences?.dayOfWeeks?.includes('MONDAY') : false,
        day1: pageData?.postPreferences?.dayOfWeeks?.length > 0 ? pageData?.postPreferences?.dayOfWeeks?.includes('TUESDAY') : false,
        day2: pageData?.postPreferences?.dayOfWeeks?.length > 0 ? pageData?.postPreferences?.dayOfWeeks?.includes('WEDNESDAY') : false,
        day3: pageData?.postPreferences?.dayOfWeeks?.length > 0 ? pageData?.postPreferences?.dayOfWeeks?.includes('THURSDAY') : false,
        day4: pageData?.postPreferences?.dayOfWeeks?.length > 0 ? pageData?.postPreferences?.dayOfWeeks?.includes('FRIDAY') : false,
        day5: pageData?.postPreferences?.dayOfWeeks?.length > 0 ? pageData?.postPreferences?.dayOfWeeks?.includes('SATURDAY') : false,
        day6: pageData?.postPreferences?.dayOfWeeks?.length > 0 ? pageData?.postPreferences?.dayOfWeeks?.includes('SUNDAY') : false,
        marketPlace: pageData?.postPreferences?.companyPrefMiles || '',
        milesInput: pageData?.postPreferences?.companyPrefMiles || '',
        sellerBusinessCategory: pageData?.locationPreference?.businessCategory || '',
        sellerBussPrefPalletType: pageData?.locationPreference?.typeOfPallets || [],
        sellerBussPrefPalletSize: pageData?.locationPreference?.palletSize || [],
        sellerBussPrefSpecialServices: pageData?.locationPreference?.specializedService || []
    }
}
const VALIDATION_SCHEMA = Yup.object().shape({
    name: Yup.string().email('Please enter a valid email.').required('Email is required.'),
    accountType: Yup.string().required('OTP is required.'),
});

export { VALIDATION_SCHEMA };